import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { Portal } from 'react-portal';

import { ActionButton } from 'components/UI/ActionButton';
import { SqueezedModal } from 'components/modal/SqueezedModal';
import { ShareModalContent } from 'components/ShareModalContent';
import * as Types from 'types';

const origin = window.location.origin;

type Props = {
  artistSlug: string;
  collectionSlug: string;
};

export const CollectionDetail: FC<Props> = ({ artistSlug, collectionSlug }) => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const collectionPath = Routes.artist_collection_path(artistSlug, collectionSlug);

  const artworkGroup = useSelector(({ artworkGroups }: Types.RootState) => {
    return artworkGroups.bySlug[collectionSlug];
  }) as Types.ArtworkGroup | undefined;

  return (
    <>
      <Portal node={$('.js-artwork-actions__share')[0]}>
        <ActionButton handleClick={() => setIsShareModalOpen(true)} icon='share' label='Share' />
      </Portal>
      <SqueezedModal isOpen={isShareModalOpen} onRequestClose={() => setIsShareModalOpen(false)}>
        {artworkGroup ? (
          <ShareModalContent url={`${origin}${collectionPath}`} title={artworkGroup.title} />
        ) : undefined}
      </SqueezedModal>
    </>
  );
};
